module.exports = __webpack_public_path__ + "img/IMGP8626b.714005df.jpg";